// ANCHOR React
import React from 'react';

// ANCHOR Base
import { InputOverrides, SIZE } from 'baseui/input';
import { FormControl, FormControlOverrides } from 'baseui/form-control';
import { Textarea } from 'baseui/textarea';
import { Block } from 'baseui/block';
import { ParagraphXSmall } from 'baseui/typography';

// ANCHOR Interweave
import { Markup } from 'interweave';

// ANCHOR Hooks
import { useConstantCallback } from '@lyon/utils/hooks/useConstantCallback';

// ANCHOR Styles
import { TEXT, TOOLTIP } from './styles';

interface IProps {
  value?: string | number;
  label?: string;
  caption?: string;
  tooltip?: string;
  onChange?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  autoComplete?: string;
  placeholder?: string;
  required?: boolean;
  errorMessage?: string;
  error?: boolean;
  disabled?: boolean;
  type?: string;
  name?: string;
  inputOverrides?: InputOverrides;
  formOverrides?: FormControlOverrides;
}

export function FormTextArea({
  value, type, label, caption, tooltip, autoComplete,
  onChange, placeholder, required, disabled,
  error, errorMessage, name, inputOverrides,
  formOverrides,
}: IProps) {
  const [focused, setFocused] = React.useState<boolean>(false);

  const focus = useConstantCallback(() => setFocused(true));
  const blur = useConstantCallback(() => setFocused(false));

  return (
    <FormControl
      label={label}
      caption={caption}
      error={!focused && error && errorMessage}
      overrides={formOverrides}
    >
      <>
        <Textarea
          type={type}
          value={value}
          onChange={onChange}
          autoComplete={autoComplete}
          placeholder={placeholder}
          size={SIZE.default}
          onFocus={focus}
          onBlur={blur}
          error={error}
          required={required}
          disabled={disabled}
          overrides={inputOverrides ?? {
            Input: {
              style: {
                maxHeight: '600px',
                minHeight: '200px',
                resize: 'vertical',
              },
            },
          }}
          name={name}
        />
        {(focused && tooltip) && (
          <Block position="relative">
            <Block overrides={TOOLTIP}>
              <ParagraphXSmall overrides={TEXT}>
                <Markup content={tooltip} />
              </ParagraphXSmall>
            </Block>
          </Block>
        )}
      </>
    </FormControl>
  );
}
